import { render, staticRenderFns } from "./minor-programs-modal.vue?vue&type=template&id=430f39a1&scoped=true"
import script from "./minor-programs-modal.vue?vue&type=script&lang=js"
export * from "./minor-programs-modal.vue?vue&type=script&lang=js"
import style0 from "./minor-programs-modal.vue?vue&type=style&index=0&id=430f39a1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "430f39a1",
  null
  
)

export default component.exports